export interface GeographicPermission {
    id: string;
    region?: string;
    province?: string;
    city?: string;
    permissionType: GeographicPermissionType;
}

export enum GeographicPermissionType {
    REGION = "REGION",
    PROVINCE = "PROVINCE",
    CITY = "CITY"
}

export interface GeographicPermissionRequest {
    region?: string;
    province?: string;
    city?: string;
    permissionType: GeographicPermissionType;
}
